import React, { useState } from 'react';
import { Printer, Scan, Check, Zap, Shield } from 'lucide-react';
import img1 from '../components/images/Barcode/BD2.png'
import img2 from '../components/images/Barcode/BD5.png'
import img3 from '../components/images/Barcode/BD6.png'
import img4 from '../components/images/Barcode/BM3.png'
import img5 from '../components/images/Barcode/BM4.png'
import img6 from '../components/images/Barcode/BI3.png'
import img7 from '../components/images/Barcode/BI4.png'
import img8 from '../components/images/Barcode/scanner/LS2208.jpg'
import img9 from '../components/images/Barcode/scanner/DS8100.jpg'
import img10 from '../components/images/Barcode/scanner/xenon-general.avif'
import img11 from '../components/images/Barcode/scanner/granit.webp'
import img12 from '../components/images/Barcode/scanner/li3600.jpg'

export default function BarcodeProducts() {
  const [activeCategory, setActiveCategory] = useState('printers');

  const printers = [
    {
    id: 1,
    name: "ZD200 Series - Zebra",
    price: "Affordable",
    image: img1,
    features: [
    "Engineered with Zebra quality",
    "Reliable operation for long-term use",
    "Value model without cutting corners",
    "Built for consistent performance at a low cost"
    ],
    popular: true
    },
    {
    id: 2,
    name: "PC45D - Honeywell",
    price: "Affordable",
    image: img2,
    features: [
      "4-inch direct thermal printing",
      "Large touchscreen interface",
      "Enterprise-level rugged design",
      "Low label and ribbon warning system",
      "Optimized to reduce downtime"
    ],
    popular: true
  },
  {
    id: 3,
    name: "PC42E-T - Honeywell",
    price: "Affordable",
    image: img3,
    features: [
      "Compact and reliable desktop design",
      "Efficient printing performance",
      "Easy manageability and maintenance",
      "User-friendly operation",
      "Consistent and durable output"
    ],
    popular: false
    },

    {
    "id": 4,
    "name": "RP4F - Honeywell",
    "price": "Affordable",
    "image": img4,
    "features": [
      "Mobile thermal printing for rugged environments",
      "Exceptional media and battery capacity",
      "Engineered for durability and long-term use",
      "Designed to boost efficiency and reduce downtime",
      "Excellent value for industrial operations"
    ],
    "popular": false
  },

  {
    "id": 5,
    "name": "ZQ600 Plus Series - Zebra",
    "price": "Affordable",
    "image": img5,
    "features": [
      "Enhanced version of the popular QLn platform",
      "Advanced technology for superior performance",
      "Innovative design for higher productivity",
      "Easy to use and manage in demanding environments",
      "Built to improve efficiency and workflow"
    ],
    "popular": false
  },
  {
    "id": 6,
    "name": "ZT100 Series - Zebra",
    "price": "Affordable",
    "image": img6,
    "features": [
      "Fast print speeds",
      "Crisp print quality",
      "All-metal frame for durability",
      "Security features for reliable operation",
      "Cost-effective solution for growing printing needs"
    ],
    "popular": false
  },

  {
    "id": 7,
    "name": "PX45 - Honeywell",
    "price": "Affordable",
    "image": img7,
    "features": [
      "Flexible and compact industrial printer",
      "Optimizes printing operations",
      "Quick return on investment",
      "Reliable and efficient performance",
      "Designed for industrial-scale usage"
    ],
    "popular": true
  }
  ];

  const scanners = [
    {
    id: 1,
    name: "LS2208 ID Scanner - Zebra",
    price: "Affordable",
    image: img8,
    features: [
      "Captures virtually all 1D barcodes on any surface",
      "Built on the best-selling LS2208 design",
      "Enhanced support for mobile barcodes",
      "Delivers reliable and fast 1D barcode scanning",
      "Corded linear imager for consistent performance"
    ],
    popular: false
  },
  
  {
    "id": 2,
    "name": "DS8100 1D/2D Scanners - Zebra",
    "price": "Affordable",
    "image": img9,
    "features": [
      "Ultimate performance and innovation",
      "Reads virtually every barcode type",
      "Superior scan range for fast capture",
      "Swappable power options for flexibility",
      "Advanced manageability for enterprise use"
    ],
    "popular": false
  },
  {
    "id": 3,
    "name": "Xenon XP 1952 Battery-Free Scanner - Honeywell",
    "price": "Affordable",
    "image": img10,
    "features": [
      "Powered by supercapacitors – no battery required",
      "Latest area-imager technology",
      "Reliable barcode scanning performance",
      "Eco-friendly and maintenance-free design",
      "Honeywell Extreme Performance (XP) series"
    ],
    "popular": true
  },
  {
    "id": 4,
    "name": "Granit XP 1990iXLR - Honeywell",
    "price": "Affordable",
    "image": img11,
    "features": [
      "Premium scanning performance",
      "Extended range scanning depth",
      "Built for mission-critical environments",
      "Exceptional durability and reliability",
      "Optimized for industrial use"
    ],
    "popular": false
  },

  {
    "id": 5,
    "name": "LI3600 Ultra Rugged - Zebra",
    "price": "Affordable",
    "image": img12,
    "features": [
      "Ultra-rugged design for harsh environments",
      "Reads barcodes at long distances and high speeds",
      "Nonstop, full-shift power performance",
      "Versatile and easy to use",
      "Built for maximum productivity and uptime"
    ],
    "popular": false
  }

  ];

  const currentProducts = activeCategory === 'printers' ? printers : scanners;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 font-poppins">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 min-h-screen bg-white shadow-xl pt-24">
          <div className="p-6 border-b border-slate-200">
            <h2 className="text-2xl font-bold text-slate-800">Products</h2>
            <p className="text-sm text-slate-500 mt-1">Choose a category</p>
          </div>
          
          <nav className="p-4">
            <button
              onClick={() => setActiveCategory('printers')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 mb-2 ${
                activeCategory === 'printers'
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-200'
                  : 'bg-slate-50 text-slate-700 hover:bg-slate-100'
              }`}
            >
              <Printer className="w-5 h-5" />
              <span className="font-medium">Barcode Printers</span>
            </button>
            
            <button
              onClick={() => setActiveCategory('scanners')}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                activeCategory === 'scanners'
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-200'
                  : 'bg-slate-50 text-slate-700 hover:bg-slate-100'
              }`}
            >
              <Scan className="w-5 h-5" />
              <span className="font-medium">Barcode Scanners</span>
            </button>
          </nav>

          <div className="p-6 mt-8 mx-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-100">
            <Shield className="w-8 h-8 text-blue-600 mb-2" />
            <h3 className="font-semibold text-slate-800 mb-1">Need Help?</h3>
            <p className="text-sm text-slate-600">Contact our experts for product recommendations</p>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 pt-24">
          <div className="max-w-6xl mx-auto">
            <div className="mb-8">
              <h1 className="text-4xl font-bold text-slate-800 mb-2">
                {activeCategory === 'printers' ? 'Barcode Printers' : 'Barcode Scanners'}
              </h1>
              <p className="text-slate-600">
                {activeCategory === 'printers' 
                  ? 'Professional thermal label and barcode printing solutions'
                  : 'High-performance barcode scanning devices for every need'}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {currentProducts.map((product) => (
                <div
                  key={product.id}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group border border-slate-200"
                >
                  {product.popular && (
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs font-semibold px-3 py-1 text-center">
                      ⭐ MOST POPULAR
                    </div>
                  )}
                  
                  <div className="p-6">
                    <div className="text-6xl mb-4 text-center group-hover:scale-110 transition-transform duration-300">
                      <img src={product.image} className='object-fit-contain'></img>
                    </div>
                    
                    <h3 className="text-xl font-bold text-slate-800 mb-2">
                      {product.name}
                    </h3>
                    
                    <div className="flex items-baseline gap-2 mb-4">
                      <span className="text-3xl font-bold text-blue-600">
                        {product.price}
                      </span>
                      <span className="text-slate-500 text-sm">one-time</span>
                    </div>

                    <div className="space-y-2 mb-6">
                      {product.features.map((feature, index) => (
                        <div key={index} className="flex items-start gap-2">
                          <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                          <span className="text-sm text-slate-600">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2">
                      <Zap className="w-4 h-4" />
                      View Details
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-white rounded-xl shadow-lg p-8 border border-slate-200">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-3xl mb-2">🚚</div>
                  <h4 className="font-semibold text-slate-800 mb-1">Free Shipping</h4>
                  <p className="text-sm text-slate-600">On orders over $500</p>
                </div>
                <div>
                  <div className="text-3xl mb-2">🛡️</div>
                  <h4 className="font-semibold text-slate-800 mb-1">2-Year Warranty</h4>
                  <p className="text-sm text-slate-600">Full coverage included</p>
                </div>
                <div>
                  <div className="text-3xl mb-2">💬</div>
                  <h4 className="font-semibold text-slate-800 mb-1">24/7 Support</h4>
                  <p className="text-sm text-slate-600">Expert technical assistance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}